import { useEffect } from 'react';

/**
 * Makes browser back button close a modal instead of navigating away.
 *
 * Usage:
 *   useModalHistory(isOpen, onClose);
 *
 * When the modal opens, pushes a dummy history entry so back button hits it first.
 * When back is pressed, popstate fires and we call onClose instead of leaving the page.
 * When the modal closes normally (X / submit), we pop the dummy entry cleanly.
 */
export default function useModalHistory(isOpen, onClose) {
  useEffect(() => {
    if (!isOpen) return;

    // Push a dummy state so back button has something to hit
    window.history.pushState({ modal: true }, '');

    const handler = (e) => {
      // Browser went back — close the modal, don't navigate
      onClose();
    };

    window.addEventListener('popstate', handler);

    return () => {
      window.removeEventListener('popstate', handler);
      // If modal closed without back button, pop the dummy entry we pushed
      if (window.history.state?.modal) {
        window.history.back();
      }
    };
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps
}
